<template>
  <div class="audit-status-container" v-if="certStatusImg">
    <img class="audit-status-container__img" :src="certStatusImg.img" :alt="certStatusImg.text" />
    <span
      :class="['audit-status-container__text', `audit-status-container__text--${certStatusImg.type}`]"
    >
      {{ certStatusImg.text }}
    </span>
  </div>
</template>
<script>
import { mixins } from '@/utils';

export default {
  name: 'status-info',
  mixins: [mixins],
  props: {
    certification: {
      type: Object,
      default: () => {},
    },
  },
}
</script>
<style lang="scss" scoped>
@import './style.scss';
</style>